import { lazy } from 'react';

/**
 * The signed-in student pages, and the chrome they need.
 *
 * The sibling of `landingScreens.js`, and the second — and last — place the
 * app root is allowed to reach into `src/modules`.
 *
 * WHY A SECOND BRIDGE AND NOT A LINE IN THE FIRST
 *
 * `landingScreens.js` is imported by `LandingLayout` and `LandingStack`, which
 * are what a signed-out visitor renders. This file is imported by
 * `StudentLayout` and `StudentStack`, which only a signed-in student renders.
 * Folding both into one file would put every landing page in the student
 * bundle and every student page in the landing one, because a module's imports
 * are resolved whether or not the importer uses them.
 */
export const Dashboard = lazy(() => import('../modules/student/pages/Home'));
export const Profile = lazy(() => import('../modules/student/pages/Profile'));
export const Subscriptions = lazy(() => import('../modules/student/pages/Subscriptions'));
export const CourseDetails = lazy(() => import('../modules/student/pages/CourseDetails'));
export const ExamResults = lazy(() => import('../modules/student/pages/ExamResults'));

/**
 * The four question banks and a lesson's knowledge test — one page for all
 * five; it reads which from its route. Only the banks' setup and the MCQ
 * report are new: the page is still the old `ExamGate` with those handed in,
 * so an exam already under way and the exam itself are the old screens.
 */
const QuestionBank = lazy(() => import('../modules/student/pages/QuestionBank'));

export const McqsBank = QuestionBank;
export const EssaysBank = QuestionBank;
export const TbsBank = QuestionBank;
export const FileBank = QuestionBank;
export const KnowledgeTest = QuestionBank;

/**
 * Chrome for the student pages: the header, the root wrapper and the dialogue
 * for important notifications, and the question which paths use the root.
 */
export { isV2StudentRoute } from '../modules/shared/routes';
export { V2Root } from '../modules/shared/components';
export { ImportantNotifications, StudentHeader } from '../modules/student/components/shared';
